import React, { useState } from "react";
import { pdfjs, Document, Page } from 'react-pdf';

//react-pdf styles
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Row, } from "reactstrap";
import jsonWorker from "./vendor/pdf.worker.min.json";
import LoadingLocal from "plugins/TS-lib-utils-public/components/Loading/LoadingLocal";

/*Import pdf worker as a JSON file, then convert to blob and generate a valid URL 
(Firefox does not load invalid MIME types like mjs)*/
var workerBlob = new Blob([jsonWorker],{type : 'text/javascript'});
var workerBlobURL = URL.createObjectURL(workerBlob);

//react-pdf worker config
pdfjs.GlobalWorkerOptions.workerSrc = workerBlobURL; //`//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ReportViewerRenderer = ({ 
    file,
    setNumPages,
    pageHeight,
    setPageHeight,
    pageNumber,
    setLoadingPDF
 }) => {

    const width = window.visualViewport.width > 1080 ? 1080 : window.visualViewport.width;

    const onDocumentLoadSuccess = async (pdf) => {
        setLoadingPDF(false);
        //Get height of the page
        const heightOfPage = await pdf
        .getPage(1)
        .then((page) => page.getViewport({ scale: 1.4 }).height);

        setNumPages(pdf.numPages);
        setPageHeight(heightOfPage);
    }

    const isLoading = () => {
        setLoadingPDF(true);
        return <LoadingLocal />;
    }

    return (
        <>
            {file && 
                <>

                    <Row className="text-center justify-content-center mt-3">
                        <div style={{minHeight: `${pageHeight}px`}}>
                            <Document 
                                file={{data: file}} 
                                onLoadSuccess={onDocumentLoadSuccess} 
                                loading={isLoading}
                            >
                                <Page 
                                    width={width/1.4}
                                    pageNumber={pageNumber}
                                ></Page>
                            </Document>
                        </div>
                    </Row>
                    
                </>
            }
        </>
    )
}

export default React.memo(ReportViewerRenderer);